export const scheduleErrorCodes = {
  SCHEDULE_MISSING_ID: 10001,
  SCHEDULE_MISSING: 10002,
  SCHEDULE_MISSING_TASK: 10003,
  SCHEDULE_MISSING_SOURCE_TASK: 10004,
  SCHEDULE_MISSING_TARGET_TASK: 10005,
  SCHEDULE_MISSING_NAMED_VERSION: 10006,
  SCHEDULE_MISSING_SOURCE_VERSION: 10007,
  SCHEDULE_VERSION_ALREADY_CURRENT: 10008,
  SCHEDULE_VERSION_FAILED_CREATE_NEW: 10009,
  SCHEDULE_SET_AS_TOP_VERSION: 10010,
  SCHEDULE_IMPORT_FILE: 10011,
};
